// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3JBsl","header":"MessagesList_header__17iE3","chat":"MessagesList_chat__sga24"};